<template>
    <section class="hero" ref="heroSlider">
        <section
            v-for="(slide, index) in slides"
            :key="`slide_${index}`"
            @click="handleOuterClick(slide)"
            :class="['hero-slide', { 'hero-slide-first': index === 0 }]"
        >
            <img
                v-rellax="{ speed: -1, wrapper: '.hero' }"
                ref="slideImage"
                :src="slide.image"
                :alt="slide.title"
                class="hero-slide__image js-rellax"
            />
            <div class="container">
                <img
                    v-if="index === 0"
                    :src="logo"
                    alt="logo"
                    class="hero-slide__logo hidden-from-md"
                />
                <div :class="['hero-slide-box', slide.outline]">
                    <h1 v-if="index === 0" class="hero-slide-box__title">
                        {{ slide.title }}
                    </h1>
                    <h2 v-else class="hero-slide-box__title">
                        {{ slide.title }}
                    </h2>
                    <p class="hero-slide-box__content hidden-until-md">
                        {{ slide.content }}
                    </p>
                    <a
                        v-if="slide.link"
                        :href="slide.link"
                        class="button hidden-until-md"
                    >
                        {{ slide.link_text }}
                    </a>
                </div>
            </div>
            <slot v-if="index === 0" />
        </section>
    </section>
</template>

<script>
import ScrollSnap from 'scroll-snap';
import $ from 'jquery';

export default {
    name: 'SectionSlider',
    data() {
        return {
            snapObject: '',
            parallax: '',
            snapConfig: {
                snapDestinationX: '0%',
                snapDestinationY: '100vh',
                timeout: 10,
                duration: 250,
                threshold: 0.2,
            },
        };
    },
    props: {
        slides: {
            type: Array,
            default: () => [],
        },
        logo: {
            type: String,
            default: '',
        },
        config: {
            type: Object,
            default: {},
        },
    },
    mounted() {
        this.setupSnapScroll();
        this.handleOverscroll();
    },
    methods: {
        handleOuterClick(slide) {
            if (slide.link) {
                window.location.href = slide.link;
            }
        },

        setupSnapScroll() {
            this.snapConfig = Object.assign(this.snapConfig, this.config);
            this.snapObject = new ScrollSnap(
                this.$refs.heroSlider,
                this.snapConfig,
            );
            this.snapObject.bind();
        },

        handleOverscroll() {
            $(window).scroll(() => {
                const scroll = $(window).scrollTop();
                if (scroll > 0) {
                    $('.hero').addClass('is-scrolled');
                } else {
                    $('.hero').removeClass('is-scrolled');
                }
            });
        },
    },
};
</script>

<style lang="scss">
.hero {
    margin: 0;
    background: #fff;

    @include respond-to(md) {
        height: 100vh;
        overflow: auto;

        &.is-scrolled {
            overflow: hidden;
        }
    }

    @include respond-to(md) {
        margin: 0 0 0;
    }

    &::-webkit-scrollbar {
        display: none;
    }

    &-slide {
        position: relative;
        display: flex;
        min-height: 50vh;
        margin: 0 30px;
        overflow: hidden;

        @include respond-to(md) {
            margin: 0 30px 30px;
        }

        &-first {
            align-items: center;
            justify-content: center;
            width: 100%;
            padding: 50px;
            margin: 0 0 30px;

            @include respond-to(md) {
                margin: 0;
            }

            @include respond-to(until, md) {
                .hero-slide-box {
                    display: none;
                }
            }
        }

        @include respond-to(md) {
            align-items: center;
            width: 100%;
            height: 100vh;
            margin: 0;
        }

        .container {
            display: flex;
        }

        &-box {
            position: relative;
            z-index: 15;
            width: auto;
            padding: 10px 16px;
            background: #fff;

            @include respond-to(until, md) {
                margin: auto auto 72px;
            }

            @include respond-to(md) {
                max-width: 488px;
                padding: 32px;
            }

            &.right {
                margin-left: auto;
            }

            &.center {
                position: absolute;
                bottom: 30px;
                left: 50%;
                padding: 0;
                background: none;
                transform: translateX(-50%);

                .button {
                    font-size: 36px;
                }
            }

            &__title {
                @include titleWithBorder();
                display: inline-block;
                margin: 0;
                font-size: 35px;
                line-height: 1.14;
                text-align: center;

                @include respond-to(md) {
                    margin: 0 0 15px;
                    text-align: left;
                }
            }

            &__content {
                margin: 0;
                font-size: 21px;
                font-weight: bold;
                line-height: 1.5;
            }

            .button {
                margin-top: 30px;
            }
        }

        &__image {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            object-fit: cover;

            @include respond-to(md) {
                top: -20vh;
                height: 120vh;
            }
        }

        &__logo {
            position: relative;
            width: 100%;
            height: auto;
        }
    }

    &-usp {
        display: flex;
        flex: 1 0 calc(100% / 3);
        align-items: center;
        justify-content: center;
        max-width: calc(100% / 3);
        font-size: 20px;
        font-weight: bold;
        text-align: center;

        &:nth-child(1) {
            justify-content: flex-start;
        }

        &:nth-child(3) {
            justify-content: flex-end;
        }

        .icon {
            margin-right: 9px;
            color: var(--primary-color);
        }

        &s {
            display: flex;
            align-items: center;
            width: 100%;

            &-wrapper {
                position: absolute;
                bottom: 0;
                left: 0;
                width: 100%;
                padding: 25px 0;
            }
        }
    }
}
</style>
